const medicine = [
    {
        "code": "TAF-MM110009",
        "category": "MM",
        "name": "醫學實驗室認證規範ISO 15189訓練",
        "classDate": "2021/10/13~2021/10/15",
        "studentQualification": "適用於醫學實驗室工作之醫師、醫檢師、品管人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "full",
        "enrollmentType": "waiting",
        "location": "線上",
        "cost": "新台幣7700",
        "description": "國際標準ISO 15189「Medical laboratories - Particular requirements for quality and competence」已於2003年2月15日公告成為醫學實驗室建立品質管理系統之標準。" +
            "本國際標準可適用於執行包括解剖病理學、臨床生化學、輸血醫學、血液學、臨床免疫血清學、臨床微生物學、臨床毒物學、細胞遺傳學與分子病理學及生醫產業等之醫學實驗室。\n" + "\n" +
            "本課程將完整介紹ISO 15189條文之要求，及TAF 醫學測試領域認證規範之實務應用。\n" + "\n" +
            "全程參與且通過測驗者將由本會頒發ISO 15189訓練合格證書。",
        "outline": "第一天\n" + "\n" +
            "組織與管理、品質管理系統、文件管制、檢驗合約之審查、委託檢驗、外部的服務與供應、諮詢服務、抱怨處理、人員\n" + "\n" +
            "第二天\n" + "\n" +
            "不符合性事物的鑑別與管制、矯正措施、預防措施、持續改善、品質與技術紀錄、內部稽核、管理審查、設施與環境條件 \n" + "\n" +
            "第三天\n" + "\n" +
            "實驗室設備、檢驗前程序、檢驗程序、檢驗程序品質保證、檢驗後程序、結果報告",
        "remark": "★實體課程，請注意下列事項\n" +
            "1.疫情期間，將視疫情狀況調整人數。\n" +
            "2.本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3.若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4.參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$7,200(含稅)。"
    },
    {
        "code": "TAF-MM110010",
        "category": "MM",
        "name": "醫學實驗室認證規範ISO 15189訓練",
        "classDate": "2021/11/02~2021/11/04",
        "studentQualification": "適用於醫學實驗室工作之醫師、醫檢師、品管人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "線上",
        "cost": "新台幣7700",
        "description": "國際標準ISO 15189「Medical laboratories - Particular requirements for quality and competence」已於2003年2月15日公告成為醫學實驗室建立品質管理系統之標準。" +
            "本國際標準可適用於執行包括解剖病理學、臨床生化學、輸血醫學、血液學、臨床免疫血清學、臨床微生物學、臨床毒物學、細胞遺傳學與分子病理學及生醫產業等之醫學實驗室。\n" + "\n" +
            "本課程將完整介紹ISO 15189條文之要求，及TAF 醫學測試領域認證規範之實務應用。\n" + "\n" +
            "全程參與且通過測驗者將由本會頒發ISO 15189訓練合格證書。",
        "outline": "第一天\n" + "\n" +
            "組織與管理、品質管理系統、文件管制、檢驗合約之審查、委託檢驗、外部的服務與供應、諮詢服務、抱怨處理、人員\n" + "\n" +
            "第二天\n" + "\n" +
            "不符合性事物的鑑別與管制、矯正措施、預防措施、持續改善、品質與技術紀錄、內部稽核、管理審查、設施與環境條件 \n" + "\n" +
            "第三天\n" + "\n" +
            "實驗室設備、檢驗前程序、檢驗程序、檢驗程序品質保證、檢驗後程序、結果報告",
        "remark": "★實體課程，請注意下列事項\n" +
            "1.疫情期間，將視疫情狀況調整人數。\n" +
            "2.本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3.若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4.參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$7,200(含稅)。"
    },
    {
        "code": "TAF-MH110002",
        "category": "MH",
        "name": "醫學實驗室主管訓練",
        "classDate": "2021/10/20~2021/10/22",
        "studentQualification": "適用於醫學實驗室工作之醫師、醫檢師、品管人員及有興趣者。參加者應先取得本會辦理之「醫學實驗室認證標準ISO 15189訓練」合格證書。",
        "firstCourse": "醫學實驗室認證規範ISO 15189訓練",
        "enrollment": "50",
        "enrollmentStatus": "full",
        "enrollmentType": "waiting",
        "location": "線上",
        "cost": "新台幣7700",
        "description": "本課程共分兩天實施，第一天介紹制度性之要求，如TAF認證流程、如何建立符合TAF認證準備計畫、及實驗室評鑑實務經驗等；" +
            "第二天介紹技術性之要求，包括如何推動實驗室內部稽核與管理審查、能力試驗及設備管理等，以使實驗室主管了解認證相關要求及準備計畫。\n" + "\n" +
            "全程參與且通過測驗者將由本會頒發醫學實驗室主管訓練合格證書。。",
        "outline": "分為以下單元，為您完整介紹擔任醫學實驗室主管之要求\n" + "\n" +
            "n           認證要求：說明TAF認證要求及評鑑流程各階段之做法，及認可實驗室之權利與義務。\n" +
            "n           認證準備：說明實驗室導入認證之重要性與準備工作，以及組織人力規劃。\n" +
            "n           實驗室主管要求：說明實驗室主管該具備之條件及要求。\n" +
            "n           儀器管理及校正：說明儀器管理及量測追溯性。\n" +
            "n           內部稽核與管理審查：說明實驗室主管如何辦理內部稽核與管理審查，以了解品質系統之適切性及有效性。\n" +
            "n           能力試驗：說明能力試驗之國際標準ISO/IEC 43，及如何應用參與能力試驗之結果。\n" +
            "n           量測不確定度：介紹TAF測試實驗室量測不確定度評估指引。\n" +
            "     報告管理：報告簽署之作法及要求。",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$5,200(含稅)。"
    },
    {
        "code": "TAF-MG110004",
        "category": "MG",
        "name": "醫學實驗室內部稽核研討會",
        "classDate": "\t2021/12/16~2021/12/17",
        "studentQualification": "適用於擔任實驗室品質主管，及對稽核工作之同仁及有興趣者。參加者應先取得本會辦理之「醫學實驗室認證標準ISO 15189訓練」合格證書。",
        "firstCourse": "醫學實驗室認證規範ISO 15189訓練",
        "enrollment": "24",
        "enrollmentStatus": "full",
        "enrollmentType": "waiting",
        "location": "台北",
        "cost": "新台幣5500",
        "description": "本課程共分兩天實施，將介紹ISO/IEC 15189之重點及國際間對稽核引用之新版標準－ISO 19011，包括稽核指導綱要之架構、稽核內容重點、稽核原則、稽核計畫管理、稽核活動及稽核員能力與評估，並導入實務案例演練。" +
            "以使實驗室品管人員瞭解如何推動實驗室內部稽核，及運用稽核結果作為品質提昇之工具。\n" + "\n" +
            "全程參與將由本會頒發參加證書。",
        "outline": "請於課前預習ISO 15189條文\n" +
            "第一天\n" +
            "n基本觀念：說明內部稽核之重要性及應用。\n" +
            "n稽核標準：說明ISO 15189之重點及 ISO 19011稽核。\n" +
            "n稽核計畫：說明稽核內容重點、稽核原則及稽核計畫管理。\n\n" +
            "第二天\n" +
            "n稽核技巧：說明實施稽核應注意事項及稽核技巧。\n" +
            "n稽核查檢表: 說明如何設計水平式查檢表及垂直式查檢表。\n" +
            "n矯正措施: 說明實驗室常見不符合事項之矯正措施及預防再發生措施。\n" +
            "n核員管理：說明稽核員資格要求及稽核員能力與評估。\n" +
            "n ???理審查",
        "remark": "1.每班招收24人(配合中央疫情指揮中心，視疫情狀況調整人數)，開放報名至額滿為止。\n" +
            "2.本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3.若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4.參加者應先取得本會辦理之「醫學實驗室認證標準ISO 15189訓練」合格證書。\n" +
            "5.參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。"
    },
]

export default medicine;